module.exports = __webpack_public_path__ + "static/media/XLongCB.cb5d0892.png";